import { ApiService } from "@/api";

export const getGroupDetail = (groupId: string) => {
  return ApiService.baseAction("group/" + groupId, {}, "get");
};
